import { VenueData, MessageTypes, AllMessages, ErrorMessages } from "@/types";
import { MessagesState } from "@/types/store/clientzone/messages";

export const state: MessagesState = {
    selectedVenue: {} as VenueData,
    MessageType: {} as MessageTypes,
    messages: {} as AllMessages,
    errorMessage: {} as ErrorMessages
}
